import logoEUR from "../assets/images/EUR-logo-add-wallet.svg";
import logoUSD from "../assets/images/USD-logo-add-wallet.svg";
import logoUSDT from "../assets/images/USDT-logo.png";


export const listNotPrivate = ["/sign-in", "/sign-up", "/forgot-password", "/forgot-send"];

export const url = "https://api.cryptohub.exchange";

export const listNav = [{ name: "Exchange", url: "/", isExternal: false, onlyClient: true, }, { name: "Transactions", url: "/transactions-list", isExternal: false }];
// { name: "About", url: "/about", isExternal: false }
export const listNavMenu = [{ name: "Settings", url: "/settings", isExternal: false, icon: "ri-settings-2-line" }];
// { name: "Help", url: "/help", isExternal: true, icon: "ri-questionnaire-line" }


export const listCryptoCurr = ["usdt"];


export const listBankCurr = ["eur", "usd"];

export const convertIdentifiers = (input) => {
    return input.replace(/(trc|erc|bep)(\d+)/gi, (match, prefix, number) => `(${prefix.toUpperCase()}-${number})`);
}

export const listMoneyObj = [
    { img: logoUSDT, type: "usdt", isCoin: true }, { img: logoEUR, type: "eur", isCoin: false }, { img: logoUSD, type: "usd", isCoin: false }
];

export const listBankCurrObj = ["eur", "usd"];



export const checkWalletsType = (curr) => {
    const isBank = listBankCurr.includes(curr);
    const isCrypto = listCryptoCurr.includes(curr);

    if (isBank) {
        return "bank";
    } else if (isCrypto) {
        return "crypto";
    } else {
        return "none";
    }

}



// Функція для встановлення кукі з терміном дії та флагами SameSite і Secure
export const setCookie = (name, value, days) => {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie =
        name +
        "=" +
        encodeURIComponent(value || "") +
        expires +
        "; path=/" +
        "; SameSite=Strict" +
        "; Secure";
};



// Функція для отримання значення кукі за ім'ям
export const getCookie = (name) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i].trim();
        if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
};


// Функція для встановлення кукі та розбиття токена за роздільником ';'
export const setTokenCookie = (token, days) => {
    // Розбиваємо токен на 3 частини за символом ';'
    const parts = token.split(';');
    if (parts.length !== 3) {
        throw new Error('Невірний формат токена. Токен повинен містити 2 символи \';\' для розділення на 3 частини.');
    }
    const [part1, part2, part3] = parts;

    // Встановлюємо кожну частину як окрему кукі
    setCookie('img', part1, days);
    setCookie('ons', part2, days);
    setCookie('pem', part3, days);
};

// Функція для отримання токена з кукі
export const getTokenFromCookies = () => {
    const part1 = getCookie('img');
    const part2 = getCookie('ons');
    const part3 = getCookie('pem');

    if (part1 && part2 && part3) {
        // Об'єднуємо частини, додаючи ';' між ними
        return `${part1};${part2};${part3}`;
    } else {
        return null;
    }
};


// Функція для видалення кукі
export const deleteCookie = (name) => {
    document.cookie = name + "=; Max-Age=0; path=/";
};



export const checkMoney = (e) => {
    return listMoneyObj.find(element => element.type === e);
};



